import { createFileRoute, redirect } from "@tanstack/react-router"
import { childrenQueryOptions } from "@/features/children/api/children.queries"
import { EditChildPage } from "@/features/children/EditChildPage"

export const Route = createFileRoute("/_app/profil_/barn/$childId")({
  loader: async ({ context, params }) => {
    const children = await context.queryClient.ensureQueryData(childrenQueryOptions)
    if (!children.some((child) => child.id === params.childId)) {
      throw redirect({ to: "/" })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { childId } = Route.useParams()
  return <EditChildPage childId={childId} />
}
